import React, { Fragment, useState, useEffect } from 'react';
import CustomTable from '@jumbo/components/CustomTable';
import PageLoader from '@jumbo/components/custom/Spinner/pageLoader';
import VerReclamo from '../../AppComponentsNUtils/ModalVerReclamo';
import QuitReclamo from '../../AppComponentsNUtils/QuitReclamo';
import Spinner from '@jumbo/components/custom/Spinner';
import { API_EXTRANET } from 'config/config';
import { validacionPermit } from '../../../../../services/service.user';
import axios from 'axios';
import { CustomToast, toast } from '@jumbo/components/custom/Toast';
import {
  getDatosEntidadesList,
  tableHeadCells,
  tableHeadCellsIsRed,
  validaciones,
  misAsignacionesActions,
} from '../../AppComponentsNUtils/SeguimientoReclamosUtils';
import ModalProrroga from '../../AppComponentsNUtils/ModalProrroga';
import AddAntecedente from '../../AppComponentsNUtils/AddAntecedente';
import RenderFile from 'customComponents/RenderFile';
import { getNetworkMembers } from 'services/api';

const TablaReclamosPendientes = () => {
  const [primeraCarga, setPrimeraCarga] = useState(false);
  const [entidadesList, setEntidadesList] = useState([]);
  const [showVerReclamo, setShowVerReclamo] = useState(false);
  const [reclamoVer, setReclamoVer] = useState(null);
  const [showQuitarReclamo, setShowQuitarReclamo] = useState(false);
  const [reclamoQuitar, setReclamoQuitar] = useState(null);
  const [spinner, setSpinner] = useState(false);

  const [showProrroga, setShowProrroga] = useState(false);
  const [reclamoProrroga, setReclamoProrroga] = useState(null);

  const [showAddAnt, setShowAddAnt] = useState(false);
  const [reclamoAddAnt, setrReclamoAddAnt] = useState(null);

  const [url, setUrl] = useState(undefined);
  const [urlSuper, setUrlSuper] = useState(undefined);

  const [showPreview, setShowPreview] = useState(false);
  const [showPreviewSuper, setShowPreviewSuper] = useState(false);
  const [reload, setReload] = useState(false);
  const user = JSON.parse(sessionStorage.getItem('user'));

  const loadEntidades = () => {
    const user = JSON.parse(sessionStorage.getItem('user'));

    if (user.is_network) {
      if (user.organization.network_id) {
        getNetworkMembers(user.organization.network_id)
          .then(resNet => {

            const entidadesQueryString = resNet.data.members
              .map(item => `entidades=${item.name}`)
              .join('&')
            axios
              .get(`${API_EXTRANET}api/v1/userip_network?indice=reclamos_ip&${entidadesQueryString}`, {
                //.get(`${API_EXTRANET}api/v1/userIp-xpage?indice=${user.organization.name}`, {
                headers: {
                  Authorization: `Bearer ${JSON.parse(sessionStorage.getItem('user')).token}`,
                },
              })
              .then(res => {
                if (res.data) {
                  setEntidadesList(
                    res.data.map(entidad => {
                      return getDatosEntidadesList(entidad);
                    }),
                  );
                  setSpinner(false);
                  setPrimeraCarga(true);
                } else {
                  loadEntidades()
                }


              })
              .catch(err => {
                setSpinner(false);
                console.log(err);
              });

          })
          .catch(error => {
            // toast.error('Ocurrió un error al buscar los datos de la red.');
            console.error(error)
          })
          .finally(fin => {

          })
      } else {
        toast.error("El usuario está configurado como un usuario de red, por favor contactar con administrador.")
        setPrimeraCarga(true)
        setSpinner(false)
      }
  
    } else {
      axios
        .get(`${API_EXTRANET}api/v1/userIp?indice=reclamos_ip`, {
          //.get(`${API_EXTRANET}api/v1/userIp-xpage?indice=${user.organization.name}`, {
          headers: {
            Authorization: `Bearer ${JSON.parse(sessionStorage.getItem('user')).token}`,
          },
        })
        .then(res => {
          if (res.data) {
            setEntidadesList(
              res.data.map(entidad => {
                return getDatosEntidadesList(entidad);
              }),
            );
            setSpinner(false);
            setPrimeraCarga(true);
          } else {
            loadEntidades()
          }
        })
        .catch(err => {
          setSpinner(false);
          console.log(err);
        });
    }


  };

  useEffect(() => {
    loadEntidades();
  }, [reload]);

  const handleAction = (menu, item) => {
    if (menu.action === 'ver') {
      setReclamoVer(item);
      setShowVerReclamo(true);
    } else if (menu.action === 'quitar') {
      setReclamoQuitar(item);
      setShowQuitarReclamo(true);
    } else if (menu.action === 'prorroga') {
      setReclamoProrroga(item);
      setShowProrroga(true);
    } else if (menu.action === 'addAnt') {
      setrReclamoAddAnt(item);
      setShowAddAnt(true);
    }
  };

  const openModal = fila => {
    setReclamoVer(fila);
    setShowVerReclamo(true);
  };

  const verReclamoClose = () => {
    setShowVerReclamo(false);
    setReclamoVer(null);
  };

  const quitarReclamoClose = () => {
    setShowQuitarReclamo(false);
    setReclamoQuitar(null);
  };

  const quitarReclamoSubmit = () => {
    setShowQuitarReclamo(false);
    setReclamoQuitar(null);
    setSpinner(true);
    loadEntidades();
  };

  const closeModalProrroga = () => {
    setShowProrroga(false);
    setReclamoProrroga(null);
  };

  const AddAntClose = () => {
    setrReclamoAddAnt(null);
    setShowAddAnt(false);
  };

  const closePreview = () => {
    setShowPreview(false);
    setUrl('');
  };

  const cargarUrl = url => {
    setUrl(url);
    setShowPreview(true);
  };

  const closePreviewSuper = () => {
    setShowPreviewSuper(false);
    setUrlSuper('');
  };
  const cargarUrlSuper = url => {
    setUrlSuper(url);
    setShowPreviewSuper(true);
  };

  return (
    validacionPermit('search_reclaim_ip') && (
      <Fragment>
        <Spinner show={spinner} />
        <CustomToast />
        <VerReclamo
          openDialog={showVerReclamo}
          close={verReclamoClose}
          reclamo={reclamoVer}
          cargarPreview={cargarUrl}
          cargarPreviewSuper={cargarUrlSuper}
        />
        <AddAntecedente
          openDialog={showAddAnt}
          close={AddAntClose}
          reclamo={reclamoAddAnt}
          cargarPreview={cargarUrl}
          cargarPreviewSuper={cargarUrlSuper}
          setReload={setReload}
          reload={reload}
        />
        {showPreview ? <RenderFile openDialog={showPreview} url={url} close={closePreview} /> : null}
        {showPreviewSuper ? <RenderFile openDialog={showPreviewSuper} url={urlSuper} close={closePreviewSuper} /> : null}
        <ModalProrroga
          openDialog={showProrroga}
          close={closeModalProrroga}
          reclamo={reclamoProrroga}
          reload={reload}
          setReload={setReload}
        />
        <QuitReclamo
          openDialog={showQuitarReclamo}
          close={quitarReclamoClose}
          reclamo={reclamoQuitar}
          submit={quitarReclamoSubmit}
        />

        {primeraCarga ? (
          entidadesList.length === 0 ? (
            <h1 style={{ marginLeft: 16, marginTop: 10 }}>Usted no tiene reclamos asignados</h1>
          ) : (
            <CustomTable
              headCells={user.is_network ? tableHeadCellsIsRed : tableHeadCells}
              rows={entidadesList}
              title={'Reclamos'}
              validation={validaciones}
              search={true}
              actions={misAsignacionesActions}
              handleAction={handleAction}
              openModal={openModal}
            />
          )
        ) : (
          <PageLoader />
        )}
      </Fragment>
    )
  );
};

export default TablaReclamosPendientes;
